import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function OrderBumpSection() {
  const [isSelected, setIsSelected] = useState(false);
  return <section className="w-full bg-warm-gray pt-0 pb-16 px-6" data-id="element-122">
      <div className="max-w-reading mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className={`relative p-6 rounded-b-xl border-x-2 border-b-2 transition-all cursor-pointer -mt-4 pt-8 z-0 ${isSelected ? 'bg-amber/5 border-amber shadow-md' : 'bg-white/50 border-dashed border-border-gray hover:border-amber/50'}`} onClick={() => setIsSelected(!isSelected)} data-id="element-124">
          <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-amber text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-sm z-20" data-id="element-125">
            Add to your order
          </div>

          <div className="flex gap-4 items-start mt-2" data-id="element-126">
            <div className={`flex-shrink-0 w-6 h-6 rounded border-2 flex items-center justify-center mt-1 transition-colors ${isSelected ? 'bg-amber border-amber text-white' : 'bg-white border-gray-300'}`} data-id="element-127">
              {isSelected && <Check className="w-4 h-4" data-id="element-128" />}
            </div>

            <div className="flex-1" data-id="element-129">
              <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-3 mb-1" data-id="element-130">
                <h3 className="text-lg font-bold text-charcoal font-serif" data-id="element-131">
                  The Travel Night Plan
                </h3>
                <span className="text-amber font-bold" data-id="element-132">— $7</span>
              </div>
              <p className="text-charcoal/80 text-base leading-relaxed mb-2" data-id="element-133">
                Don't let one dinner out wreck your night. Use the ladder +
                elevation timing to protect your sleep when you're away from
                home.
              </p>
              <p className="text-sm text-charcoal/60 font-medium" data-id="element-134">
                1-page printable + hotel routine
              </p>
            </div>

            <div className="hidden md:block ml-auto" data-id="element-135">
              <button className={`px-4 py-2 rounded text-sm font-bold transition-colors ${isSelected ? 'bg-amber text-white' : 'bg-gray-100 text-charcoal hover:bg-gray-200'}`} data-id="element-136">
                {isSelected ? 'Added' : 'Add'}
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}